import Header from "../../header/Header";
import Footer from "../../footer/Footer";
import AffiliationInfo from "../affiliation_info/AffiliationInfo";

function AffiliationLanding(){
    return(
        <div className="personal_landing">
            <Header />
            <AffiliationInfo />
            <Footer />
        </div>
    )
}

export default AffiliationLanding